import { Card, CardContent } from "../../client/components/ui/card";
import { CardSectionHeader } from "../../client/components/ui/card-section-header";
import { useWidgetData } from "./WidgetDataContext";
import TradingRoutinesPage from "../../trading-routines/TradingRoutinesPage";

export default function DisciplineRoutinesWidget() {
  const { isDark, t } = useWidgetData();
  return (
    <Card className="h-full flex flex-col">
      <CardSectionHeader label={t.dashboard.widgets.disciplineRoutines} isDark={isDark} compact />
      <CardContent className="flex-1 overflow-auto px-4 pb-4 pt-0">
        {/* No sectionTitle → page renders no internal heading; CardSectionHeader is the only header */}
        <TradingRoutinesPage />
      </CardContent>
    </Card>
  );
}
